import { Injectable } from '@angular/core';

declare global {
  interface Window {
    google: typeof google;
    googleMapsLoaded?: boolean;
    googleMapsLoadedCallbacks?: (() => void)[];
  }
}

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoaderService {
  private static instance: GoogleMapsLoaderService;
  private isLoaded = false;
  private loadingPromise: Promise<void> | null = null;

  constructor() {
    if (GoogleMapsLoaderService.instance) {
      return GoogleMapsLoaderService.instance;
    }
    GoogleMapsLoaderService.instance = this;
  }

  public async load(): Promise<void> {
    if (this.isLoaded) {
      return Promise.resolve();
    }

    if (this.loadingPromise) {
      return this.loadingPromise;
    }

    this.loadingPromise = new Promise<void>((resolve, reject) => {
      // Check if Google Maps is already loaded
      if (window.googleMapsLoaded && window.google && window.google.maps) {
        this.isLoaded = true;
        resolve();
        return;
      }

      // Add callback to the queue
      if (window.googleMapsLoadedCallbacks) {
        window.googleMapsLoadedCallbacks.push(() => {
          this.isLoaded = true;
          resolve();
        });
      }

      // Set a timeout to prevent infinite waiting
      setTimeout(() => {
        if (!this.isLoaded) {
          reject(new Error('Google Maps failed to load within timeout'));
        }
      }, 10000); // 10 second timeout
    });

    return this.loadingPromise;
  }

  public isGoogleMapsLoaded(): boolean {
    return this.isLoaded;
  }
}